import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@material-ui/core';
import FolderSelect from './FolderSelect';
import { KbFolder } from '../types';

interface Props {
  open: boolean;
  initialFolderId: number | null;
  folders: KbFolder[];
  onConfirm: (title: string, folderId: number | null) => void;
  onCancel: () => void;
}

const ArticleDialog: React.FC<Props> = ({ open, initialFolderId, folders, onConfirm, onCancel }) => {
  const [title, setTitle] = useState('');
  const [folderId, setFolderId] = useState<number | null>(initialFolderId);

  React.useEffect(() => {
    if (open) {
      setTitle('');
      setFolderId(initialFolderId);
    }
  }, [open, initialFolderId]);

  const handleSubmit = () => {
    if (title.trim()) {
      onConfirm(title.trim(), folderId);
    }
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>New Article</DialogTitle>
      <DialogContent>
        <FolderSelect folders={folders} value={folderId} onChange={setFolderId} label="Folder" />
        <TextField
          autoFocus
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          placeholder="Article title..."
          margin="dense"
        />
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={handleSubmit} color="primary" disabled={!title.trim()}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArticleDialog;
